var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12132 17.8787C2.51184 17.4882 3.14501 17.4882 3.53553 17.8787L19.201 33.5442C19.5915 33.9347 20.2247 33.9347 20.6152 33.5442L36.2807 17.8787C36.6712 17.4882 37.3044 17.4882 37.6949 17.8787L39.1091 19.2929C39.4996 19.6834 39.4996 20.3166 39.1091 20.7071L22.0294 37.7868C20.8579 38.9584 18.9584 38.9584 17.7868 37.7868L0.707107 20.7071C0.316583 20.3166 0.316582 19.6834 0.707107 19.2929L2.12132 17.8787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarretDown);
export default __webpack_public_path__ + "static/media/icon_carret-Down.1760c5e6e044d3fafaaa1d027017dba1.svg";
export { ForwardRef as ReactComponent };